function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGalleryFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26.923 0C27.517 0 28 .482 28 1.077v25.846c0 .595-.483 1.077-1.077 1.077H1.077A1.077 1.077 0 010 26.923V1.077C0 .482.483 0 1.077 0h25.846zM2.154 18.754v7.093h23.693v-3.863L20.462 16.6l-2.247 2.247 2.07 2.068-1.524 1.523L8.615 12.291l-6.46 6.462zm0-16.6v13.554l6.461-6.46 8.077 8.075 3.77-3.768 5.385 5.384V2.154H2.154zm18.308 4.308a2.692 2.692 0 110 5.385 2.692 2.692 0 010-5.385z",
    fill: props.color
  }));
}

export default SvgIconGalleryFilled;